import React, { useEffect, useState } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom'
import {
    Flex,
    Text,
    Box,
    Heading,
    useDisclosure,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    IconButton
} from '@chakra-ui/react'
import Navbar from '../../components/Navbar'
import {
    useDeleteCompany,
    useGetCompany,
    useGetCompanyChanges,
    useUpdateCompany,
    useUser
} from '../../core/hooks'
import { useForm } from "react-hook-form";
import InviteToCompanyModal from './InviteToCompanyModal'
import DeleteFileModal from "../EditCompany/Modals/DeleteFileModal";
import Loading from "../../components/Loading";
import { REU_COMPANY_TYPES, SU_COMPANY_TYPES, EU_COMPANY_TYPES } from "../../constants/types";
import CustomDivider from "../../components/Theme/CustomDivider";
import DoneButton from "../../components/Theme/Buttons/DoneButton";
import mainStyles from "../../styles/mainStyles";
import { ReactComponent as Edit_Modal } from "../../assets/edit_modal.svg";
import Header from "./Parts/Header";
import { InitialScore } from "../../constants/chartDatas";
import ViewAssociatedUsersModal from "./Modals/ViewAssociatedUsersModal";
import DeleteUserFromCompanyModal from "./Modals/DeleteUserFromCompanyModal";
import DeleteConfirmationModal from "./Modals/DeleteConfirmationModal";
import CompanyPropertyTypes from "../../components/Theme/DataChartsParts/CompanyPropertyTypes";
import Uploads from "./Parts/Uploads";
import useRemoveUserFromCompany from "../../core/hooks/company/useRemoveUserFromCompany";
import { ReactComponent as Delete } from "../../assets/deleteUserIcon.svg";
import SyncCompanyModal from "./Modals/SyncCompanyModal";
import { COMPANY_OBJECT } from "../../constants/company/companyEnum";
import ServiceableAreas from "../EditCompany/Modals/ServiceableAreas";
import { REU } from "../../constants/user/userEnum";
import Icon from "../../components/Theme/Icon";
import httpRequest from "../../core/services/http-request";
import DetailsCompany from "./Parts/DetailsCompany";
import Details from "./Parts/Details";
import BillingUsersModal from "./Modals/BillingUsersModal";

const CompanyEditAdmin = () => {
    const {id} = useParams()
    const {user} = useUser()
    const {company: companyResponse, refetch: refetchCompany} = useGetCompany(id)
    const {company: companyChangesResponse} = useGetCompanyChanges(id)
    const {removeUser, isLoading: isLoadingRemoveUser} = useRemoveUserFromCompany()
    const {mutate: updateCompany, isLoading} = useUpdateCompany()
    const [score, setScore] = useState(InitialScore)
    const {deleteCompany, isLoadingDeleting} = useDeleteCompany()
    const history = useHistory()
    const [serviceArea, setServiceArea] = useState([])
    const {isOpen, onOpen, onClose} = useDisclosure()
    const {isOpen: isOpenServiceArea, onOpen: onOpenServiceArea, onClose: onCloseServiceArea} = useDisclosure()
    const {isOpen: isOpenDeleteFile, onOpen: onOpenDeleteFile, onClose: onCloseDeleteFile} = useDisclosure()
    const {isOpen: isOpenView, onOpen: onOpenView, onClose: onCloseView} = useDisclosure()
    const {isOpen: isOpenDeleteUser, onOpen: onOpenDeleteUser, onClose: onCloseDeleteUser} = useDisclosure()
    const {isOpen: isOpenConfirmation, onOpen: onOpenConfirmation, onClose: onCloseConfirmation} = useDisclosure()
    const {isOpen: isOpenSync, onOpen: onOpenSync, onClose: onCloseSync} = useDisclosure()
    const { isOpen: isOpenDeleteCompany, onOpen: onOpenDeleteCompany, onClose: onCloseDeleteCompany } = useDisclosure()
    const { isOpen: isBillingOpen, onOpen: onOpenBilling, onClose: onCloseBilling } = useDisclosure();
    const [files, setFiles] = useState([])
    const [company, setCompany] = useState()
    const [removeUserId, setRemoveUserId] = useState()
    const [companyTypes, setCompanyTypes] = useState([])
    const [companyType, setCompanyType] = useState('')
    const {formState: {errors}, register, handleSubmit, setValue, reset, watch} = useForm({defaultValues: COMPANY_OBJECT})
    const [fileForDelete, setFileForDelete] = useState()
    const image = watch('image', '')
    const [companyChanges, setCompanyChanges] = useState([])
    const [users, setUsers] = useState([])
    const { post } = httpRequest()

    useEffect(() => {
        if (!companyChangesResponse) return
        setCompanyChanges(companyChangesResponse.data.data)
    },[companyChangesResponse])

    const DeleteCompany = () => {
        deleteCompany(company.id,
            {
                onSuccess() {
                    history.push('/companies')
                },
            })
    }

    useEffect(() => {
        if (!companyResponse) return

        const companyData = companyResponse?.data?.data;
        setCompany(companyData)
        setFiles(companyData?.files)

        if (companyData?.propertyPriorities && companyData.propertyPriorities.length > 0) {
            setScore(JSON.parse(companyData.propertyPriorities[0]))
        }

        const resetData = {
            ...companyData,
            ownerId: companyData?.owner?.id ? String(companyData.owner.id) : ''
        };

        reset(resetData)
    }, [companyResponse, reset])

    const submit = (data) => {
        const input = {
            ...data,
            ownerId: Number(data.ownerId),
            type: companyType,
            eventType: 6,
            serviceArea: [JSON.stringify(serviceArea)],
            propertyPriorities: [JSON.stringify(score)],
        }
        updateCompany(input, {
            onSuccess() {
                history.goBack()
            }
        })
    }

    const removeUserFromCompany = (id) => {
        let type = 'associated'
        if (Number(id) === company?.owner?.id){
            type = 'owner'
        }
        let data = {
            id: id,
            type: type,
        }
        removeUser(data,{
            onSuccess:() => {
                onCloseConfirmation()
                onCloseDeleteUser()
                onCloseView()
            },
            onError: (err) => console.log(err),
        })
    }

    useEffect(() => {
        if (!company) return
        if (Object.values(REU_COMPANY_TYPES).find(item => item === company?.type)){
            setCompanyTypes(REU_COMPANY_TYPES)
        } else if (Object.values(SU_COMPANY_TYPES).find(item => item === company?.type)){
            setCompanyTypes(SU_COMPANY_TYPES)
        } else if (Object.values(EU_COMPANY_TYPES).find(item => item === company?.type)){
            setCompanyTypes(EU_COMPANY_TYPES)
        }
        setCompanyType(company?.type)
        if (company?.serviceAreas && company.serviceAreas.length > 0) {
            setServiceArea(JSON.parse(company.serviceAreas[0]))
        }
    }, [company])
    const getUsers = () => {
        post('all-users-select', {
            type: company?.owner?.type
        })
            .then((e) => {
                setUsers(e.data.data)
            })
            .catch(() => {})
    }

    useEffect(() => {
        getUsers();
    }, [company])

    if (isLoading) return <Loading />

    return (
        <>
            <form onSubmit={handleSubmit(submit)}>
                <DeleteFileModal
                    refetch={refetchCompany}
                    fileId={fileForDelete}
                    onClose={onCloseDeleteFile}
                    isOpen={isOpenDeleteFile}/>
                {company && <InviteToCompanyModal
                    company={company}
                    isOpen={isOpen}
                    onClose={onClose}/>}
                <ViewAssociatedUsersModal
                    onOpenDeleteUser={onOpenDeleteUser}
                    company={company}
                    isOpen={isOpenView}
                    onClose={onCloseView}
                    onOpenEditBilling={onOpenBilling}
                />
                <BillingUsersModal
                    onOpenDeleteUser={onOpenDeleteUser}
                    company={company}
                    isOpen={isBillingOpen}
                    onClose={onCloseBilling}
                    onOpenConfirmation={onOpenConfirmation}
                />
                <SyncCompanyModal
                    company={company}
                    history={history}
                    isOpen={isOpenSync}
                    onClose={onCloseSync}/>
                <DeleteUserFromCompanyModal
                    userId={removeUserId}
                    onOpenConfirmation={onOpenConfirmation}
                    setUserId={setRemoveUserId}
                    isOpen={isOpenDeleteUser}
                    onClose={onCloseDeleteUser}
                    company={company}/>
                <DeleteConfirmationModal
                    isOpen={isOpenConfirmation}
                    onClose={onCloseConfirmation}
                    userId={removeUserId}
                    loading={isLoadingRemoveUser}
                    removeUserFromCompany={removeUserFromCompany}
                />
                <Modal
                    isCentered
                    isOpen={isOpenDeleteCompany}
                    onClose={onCloseDeleteCompany}>
                    <ModalOverlay/>
                    <ModalContent
                        overflow="hidden"
                        borderRadius="10px"
                        minW="520px">
                        <ModalHeader
                            bg='#FF9494'
                            fontWeight="700"
                            fontSize="3xl"
                            color='black'
                            textAlign="center">
                            Delete Company
                        </ModalHeader>
                        <IconButton
                            height="unset"
                            onClick={onCloseDeleteCompany}
                            _hover={{bg: 'none',}}
                            _active={{bg: 'none',}}
                            bg="none"
                            aria-label="close button"
                            position="absolute"
                            top="1.5rem"
                            right="0.75rem"
                            icon={<Icon type="darkClose"/>}/>
                        <ModalBody
                            pb={6}
                            textAlign='center'
                            overflow="scroll"
                            maxH="600px">
                            <Text
                                fontSize='24px'
                                fontFamily='Titillium Web'
                                my={10}>
                                Are you sure you want to delete this Company?
                            </Text>
                            <Flex
                                justifyContent='space-between'
                                width='full'>
                                <Button
                                    onClick={onCloseDeleteCompany}
                                    minH='50px'
                                    color='black'
                                    width='230px'
                                    bg='#DBDADA'>
                                    Cancel
                                </Button>
                                <Button
                                    onClick={DeleteCompany}
                                    minH='50px'
                                    color='black'
                                    width='230px'
                                    bg='#FB7575'>
                                    Yes, Delete Company
                                </Button>
                            </Flex>
                        </ModalBody>
                    </ModalContent>
                </Modal>
                <Navbar minW="1240px"
                        title={(
                            <Flex>
                                <Link as='h2' m={0} to="/companies">Companies</Link>
                                <Text as='h2' m={0}>&nbsp;/&nbsp;{company?.name} / Edit Details</Text>
                            </Flex>
                        )}>
                    <DoneButton />
                </Navbar>
                <Box css={mainStyles.container} px='40px' pt='20px'>
                    <Header
                        onOpen={onOpen}
                        onOpenSync={onOpenSync}
                        company={company}
                        companyTypes={companyTypes}
                        companyType={companyType}
                        setCompanyType={setCompanyType}
                        isLoadingDeleting={isLoadingDeleting}
                        image={image}
                        setValue={setValue}/>
                    <CustomDivider />
                    <Details
                        onOpenView={onOpenView}
                        errors={errors}
                        register={register}
                        companyChanges={companyChanges}
                        company={company}/>
                    {/*<DetailsCompany*/}
                    {/*    onOpenView={onOpenView}*/}
                    {/*    errors={errors}*/}
                    {/*    register={register}*/}
                    {/*    companyChanges={companyChanges}*/}
                    {/*    company={company}*/}
                    {/*    users={users}*/}
                    {/*/>*/}
                    <CustomDivider />
                    <Heading mb={10} fontSize="xl" as="h2">
                        {user?.type === REU ? ('Property Types:') : ('Serviceable Property Types:')}
                    </Heading>
                    <CompanyPropertyTypes
                        plus={true}
                        score={score}
                        setScore={setScore} />
                    <CustomDivider />
                    <Box
                        w='full'
                        display={Object.values(EU_COMPANY_TYPES).find(item => item === company?.type) ? 'block' : 'none'}>
                        <Flex w="100%">
                            <Text
                                fontWeight='600'
                                mb={5}
                                fontSize='18px'>
                                Serviceable Areas:
                            </Text>
                        </Flex>
                        <Flex w="100%">
                            <Text
                                fontWeight='600'
                                fontSize='14px'
                                color="#2C628D">
                                Serviceable Areas - States & Counties
                            </Text>
                        </Flex>
                        <Flex
                            w="100%"
                            border="1px solid #C4C4C4"
                            borderRadius="5px"
                            justifyContent="space-between"
                            p="10px"
                            mb={20}>
                            <Text
                                fontWeight='400'
                                fontSize='18px'>
                                {(() => {
                                    if (serviceArea.length > 0) {
                                        let a = serviceArea?.map((item) => item.name + '(' + item.child.map((e) => e.name) + ')-')
                                        let res = a[a.length - 1].slice(0, -1)
                                        a.pop()
                                        a.push(res)
                                        return a.toString().replace(/(.{100})..+/, "$1…")
                                    }
                                })()}
                            </Text>
                            {
                                user && <ServiceableAreas
                                    userType={user.type}
                                    serviceArea={serviceArea}
                                    setServiceArea={setServiceArea}
                                    isOpen={isOpenServiceArea}
                                    onClose={onCloseServiceArea}/>
                            }
                            <Button
                                onClick={onOpenServiceArea}
                                leftIcon={<Edit_Modal />}
                                w="60px"
                                height="22px"
                                variant="primary"
                                backgroundColor="#FFE68D">
                                Edit
                            </Button>
                        </Flex>
                    </Box>
                    <Uploads
                        companyId={company?.id}
                        refetchCompany={refetchCompany}
                        onOpenDeleteFile={onOpenDeleteFile}
                        setFileForDelete={setFileForDelete}
                        files={files}/>
                    <Flex justifyContent='end'>
                        <Button
                            leftIcon={<Delete />}
                            w="135px"
                            bg='#F1381F'
                            mr={5}
                            color='black'
                            onClick={onOpenDeleteCompany}>
                            Delete Company
                        </Button>
                        <DoneButton />
                    </Flex>
                </Box>
            </form>
        </>
    )
}

export default CompanyEditAdmin